export default "__VITE_ASSET__C0uTq1_h__"